export const CONTACT_CONST = {
    GET_CONTACTS: "GET_CONTACTS",
    SEND_MESSAGE: "SEND_MESSAGE",
    CALL_REQUEST: "CALL_REQUEST",
}